import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { documentHeaderActions } from "../slices/documentHeader";
import { getErrorMessage } from "../../utils/errorUtils";
import { DocumentHeaderResponseDto } from "../../shared/dtos/document/DocumentHeaderResponseDto";
import { UpdateDocumentHeaderPayload } from "../../shared/interfaces/documentHeader/UpdateDocumentHeaderPayload";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getDocumentHeaders = () => async (dispatch: AppDispatch) => {
  dispatch(documentHeaderActions.setLoadingFetchAll());
  try {
    const { data } = await axiosInstance.get<
      ApiResponseDto<DocumentHeaderResponseDto[]>
    >("/document-headers", {
      headers: { requiresAuth: true },
    });

    if (data.status === ApiResponseStatus.SUCCESS && data.data) {
      dispatch(documentHeaderActions.setItems(data.data));
    }
  } catch (error) {
    dispatch(documentHeaderActions.setErrorFetchAll(getErrorMessage(error)));
  }
};

export const updateDocumentHeader =
  (payload: UpdateDocumentHeaderPayload) => async (dispatch: AppDispatch) => {
    dispatch(documentHeaderActions.setLoadingUpdate());
    try {
      const { data } = await axiosInstance.put<
        ApiResponseDto<DocumentHeaderResponseDto>
      >(`/document-headers/${payload.id}`, payload.values, {
        headers: { requiresAuth: true },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Document header updated successfully!");
        dispatch(documentHeaderActions.updateSuccess(data.data));
        dispatch(
          documentHeaderActions.setServerStatus({
            operation: "update",
            status: 200,
          }),
        );
      }
    } catch (error) {
      dispatch(documentHeaderActions.setErrorUpdate(getErrorMessage(error)));
    }
  };

export const resetDocumentHeaderServerStatus =
  () =>
  (dispatch: AppDispatch): void => {
    dispatch(documentHeaderActions.setServerStatus(null));
  };
